module.exports = __webpack_public_path__ + "fromGroomToFather-we-b.aeab4999.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/fromGroomToFather-we-b.jpg
// module id = i2fr
// module chunks = 0